import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import styled from '@emotion/styled';

const MessageWrapperBase = styled('div')(
  ({ theme }) => ({
    backgroundColor: theme.palette.action.hover,
    p: {
      marginTop: 0,
      marginBottom: 0,
      color: theme.palette.text.secondary,
    },
  }),
  addHighContrastStyles(({ theme }) => ({
    backgroundColor: theme.isDark ? 'black' : undefined,
  })),
);

export default MessageWrapperBase;
